import { Navigate } from "react-router-dom";
import { BUDGET_MODULE_PATHS } from "../constants/budgetModule";
import { useAuth } from "../state/AuthContext";
import {
  getBudgetFlowProgress,
  getSelectedBudgetModulePage,
} from "../utils/budgetFlow";
import { isAccountantUser } from "../utils/userRole";

const BudgetModuleResolverPage = () => {
  const { user } = useAuth();
  const userProgress = getBudgetFlowProgress();

  if (isAccountantUser(user)) {
    return <Navigate to={BUDGET_MODULE_PATHS.planner} replace />;
  }

  if (
    userProgress?.budgetPlannerCompleted &&
    !userProgress?.reImportBudgetPlannerProgress
  ) {
    return (
      <Navigate
        to={getSelectedBudgetModulePage() || BUDGET_MODULE_PATHS.dashboard}
        replace
      />
    );
  }

  if (userProgress?.budgetPlannerProgress) {
    return <Navigate to={BUDGET_MODULE_PATHS.mapping} replace />;
  }

  return <Navigate to={BUDGET_MODULE_PATHS.import} replace />;
};

export default BudgetModuleResolverPage;
